import React from 'react'

const Error = () => {
  return (
    <h1>OPPS,PAGE NOT FOUND!!!</h1>
  )
}

export default Error